/**
 * Implements Layout Saga
 * Main idea is to handle layout toggles here
 */
import {
  takeLatest,
  //  put,
  select,
} from 'redux-saga/effects';
import { UPDATE_CHART_LAYOUT } from '../actions/chart_picker';
// import { actionToggleWidget } from '../actions/layout';

import { IStore } from '../reducers';

function* onChangeLayout(): any {
  try {
    const mode = yield select((state: IStore) => state.chartPicker.selected);
    console.info(mode);

    // const isSingleChart = mode.cols + mode.rows === 2;

    // yield put(actionToggleWidget('trades', isSingleChart));
  } catch (err) {
    console.error(err);
  }
}

export default function* layoutSaga() {
  yield takeLatest(UPDATE_CHART_LAYOUT, onChangeLayout);
}
